/**
 * `ez.t.update_changed` — *When an update changes* (static recipe `7011`, 4 automations).
 *
 * Our own `updates.editUpdate` re-emits `update.created` with `payload.edited: true`
 * (`apps/api/src/services/updates.ts`), which is also exactly how `ez.t.update_created`
 * already excludes edits. monday has a separate `edit_update` webhook event that **never
 * fired** in the D4 recording (`discovery/api-corpus/webhooks.md` §1), so there is no monday
 * payload to copy: the `edited` flag our own outbox carries is the evidence used here.
 */
import { z } from 'zod';
import { defineTrigger } from '../block.js';
export const updateChangedParams = z.object({});
export const updateChangedTrigger = defineTrigger({
    id: 'ez.t.update_changed',
    kind: 'trigger',
    app: 'monday',
    sentencePartial: 'When an update changes',
    paramsSchema: updateChangedParams,
    subscribes: ['update.created'],
    assumed: true,
    references: () => [],
    matches: (event) => event.payload.edited === true,
    outputs: (event) => ({
        itemId: event.itemId,
        boardId: event.boardId,
        updateId: event.payload.updateId,
        updatePreview: event.payload.bodyText,
    }),
});
//# sourceMappingURL=ez.t.update-changed.js.map